import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import AdminBase from "components/layout/AdminBase";
import ProviderPayoutReportTable from "components/provider/widgets/ProviderPayoutReportTable";
import { getProviders } from "api/ProviderApi";
import filter from "lodash/filter";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import * as ProviderApi from "api/ProviderApi";
import {
  PermissionTypes,
  userHasPermission,
} from "utils/permissions/rolesPermissions";
import * as UserPermissions from "constants/UserPermissions";
import Dropdown from "components/common/Dropdown";
import Button from "components/common/Button";
import TextBox from "components/common/TextBox";
import CorporateGroupDropdown from "components/registration/elements/CorporateGroupDropdown";
import { handleErrorResponse } from "utils/request";
import { BOEHRINGER_INGELHEIM } from "constants/ProviderIds";

function AdminPayoutReport(props) {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, index) => currentYear - index);
  const recentYears = map(years, y => ({ value: y, name: y }));
  const [checkSummary, setCheckSummary] = useState(null);
  const [groupDropDownValue, setGroupDropDownValue] = useState(null);
  const [dropDownValue, setDropDownValue] = useState(BOEHRINGER_INGELHEIM);
  const [checkNumber, setCheckNumber] = useState(null);
  const [downloadParameters, setDownloadParameters] = useState({});
  const [manufacturers, setManufacturers] = useState(null);
  const [ddlYear, setDdlYear] = useState(currentYear);
  const [loading, setLoading] = useState(false);

  const checkNumberInputStyle = {
    marginTop: "0.5rem",
  };

  const fetchData = async () => {
    setLoading(true);    
    getProviders()
    .then((res) => {
        const mans = filter(res.body, { visibleInCorporateDashboard: true });
        const ddOptions = map(mans, item => ({
            value: item.id,
            name: item.name
          }));
        setManufacturers(ddOptions);
        setDropDownValue(BOEHRINGER_INGELHEIM);
    })
    .catch((err) => {
        handleErrorResponse("loading Manufacturers", err);
    })
    .finally(() => {
        setLoading(false);
    })
  };

  useEffect(() => {
    if (!manufacturers?.length) {
      fetchData();
    }
    }, []);

  const loadPayoutReport =  (model) => {    
      ProviderApi.getAdminCheckSummary(model)
      .then((res) => {
        let recs = map(res.body, (d) => ({
            ...d,
            id: d.clinicId,
        }));
        setCheckSummary(recs);
      })
      .catch((error) => {
        handleErrorResponse("loading payout report", error);
      })
  };

  const handleStatusFilterChanged = (option) => {
    setDropDownValue(option.value);
  };

  const handleGroupFilterChanged = (option) => {
    setGroupDropDownValue(option.value);
  };

  const handleCheckInput = (number) => {
    setCheckNumber(number.value);
  };

  const handleYearChanged = (option) => {
    setDdlYear(option.value);
  };

  const handleSubmit = () => {
    let search = ({
      manufacturerId: dropDownValue,
      checkNumber: checkNumber,
      redemptionYear: ddlYear,
      corporateGroupProviderId: groupDropDownValue,
    });
    loadPayoutReport(search);
  };

  useEffect(() => {    
      setDownloadParameters({
        "manufacturerId": dropDownValue,
        "checkNumber": checkNumber,
        "redemptionYear": ddlYear,
        "corporateGroupProviderId": groupDropDownValue,
      })
  }, [dropDownValue, groupDropDownValue, checkNumber])

  return (
    <AdminBase pageTitle="Admin Payout Report">    
      <div>
        <div className="flex flex-wrap">
          {props.canViewAdminPayoutReport && (
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <CorporateGroupDropdown
                data-testid="corp-group-dropdown"               
                label="&nbsp;"
                name="ddlGroup"
                value={groupDropDownValue}
                onChange={handleGroupFilterChanged}
            />
          </div>
          )}
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <Dropdown
                data-testid="provider-dropdown"
                label="&nbsp;"
                name="ddlProvider"
                value={dropDownValue}
                onChange={handleStatusFilterChanged}
                options={manufacturers}
                wide
            />
          </div>
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <Dropdown
              label="Redemption Year"
              name="ddlYear"
              wide
              placeHolder={"Choose Redemption Year"}
              value={ddlYear}
              onChange={handleYearChanged}
              options={recentYears}
            />
          </div>
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <TextBox
              label="&nbsp;"
              data-testid="text-check-number"
              name="checkNumber"
              placeholder="Enter Check Number..."
              style={checkNumberInputStyle}
              value={checkNumber}
              onChange={(data) => handleCheckInput(data)}
              input={true}
            />
          </div>
          <div className="flex-none flex flex-centered flex-column spaced-content margin-sm">
            <div style={{ height: "38px" }}></div>
            <Button
              className="margin-right-x-sm"
              onClick={() => handleSubmit()}
              disabled={!checkNumber || !groupDropDownValue}
            >
              Search
            </Button>
          </div>
        </div>
          <ProviderPayoutReportTable
            isAdminReport={true}
            canViewAdminPayoutReport={props.canViewAdminPayoutReport}
            checkData={checkSummary}
            downloadParameters={downloadParameters}
            isNHO={false}
          />        
      </div>
      </AdminBase>
  );
}

export default connect(
  (state, ownProps) => {
    const userProfile = state.user.userProfile;
    //Permissions
    const canViewAdminPayoutReport = userHasPermission(PermissionTypes.VIEW, UserPermissions.ADMIN_PROVIDER_PAYOUT_REPORT, userProfile); 
    return {
      userProfile,
      // Permissions
      canViewAdminPayoutReport,
    };
  }
)(AdminPayoutReport);
